import WidgetSkeleton from "./WidgetSkeleton";
import { Link } from "react-router-dom";
import { RefreshCw, ArrowRight } from "lucide-react";
import { useRecurringExpenseStore } from "../../recurring-expenses/store/useRecurringExpenseStore";

function fmt(n: number) {
  return n.toLocaleString("th-TH", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}

export default function RecurringExpenseSummaryWidget() {
  const { summary, summaryLoading } = useRecurringExpenseStore();

  if (summaryLoading) {
    return <WidgetSkeleton />;
  }

  const isEmpty = !summary || summary.top3.length === 0;

  if (isEmpty) {
    return (
      <Link
        to="/recurring-expenses"
        className="rounded-2xl bg-card border border-border p-4 sm:p-5 shadow-card flex items-center gap-3 hover:bg-muted/40 transition-colors group"
      >
        <div className="w-8 h-8 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
          <RefreshCw className="w-4 h-4 text-primary" />
        </div>
        <div className="flex-1">
          <p className="text-[13px] font-semibold text-foreground">
            Recurring expenses · ฿0
          </p>
          <p className="hidden sm:block text-[12px] text-muted-foreground">
            Set up recurring expenses
          </p>
        </div>
        <ArrowRight className="w-4 h-4 text-muted-foreground group-hover:text-foreground transition-colors" />
      </Link>
    );
  }

  return (
    <Link
      to="/recurring-expenses"
      className="rounded-2xl bg-card border border-border p-4 sm:p-5 shadow-card hover:bg-muted/40 transition-colors group block"
    >
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-lg bg-primary/10 flex items-center justify-center">
            <RefreshCw className="w-3.5 h-3.5 text-primary" />
          </div>
          <span className="text-[13px] font-semibold text-foreground">
            Recurring Expenses
          </span>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-[12px] text-muted-foreground">View All</span>
          <ArrowRight className="w-3.5 h-3.5 text-muted-foreground group-hover:text-foreground transition-colors" />
        </div>
      </div>

      <p className="text-[22px] font-bold text-foreground [font-variant-numeric:tabular-nums] sm:mb-3">
        ฿{fmt(summary.monthlyTotal)}
        <span className="text-[12px] font-normal text-muted-foreground ml-1">
          / mo
        </span>
      </p>

      <div className="hidden sm:block space-y-1.5">
        {summary.top3.map((item) => (
          <div key={item.id} className="flex items-center justify-between">
            <span className="text-[12px] text-muted-foreground truncate max-w-[60%]">
              {item.title}
            </span>
            <span className="text-[12px] font-medium text-foreground [font-variant-numeric:tabular-nums]">
              ฿{fmt(item.amount)}
            </span>
          </div>
        ))}
      </div>
    </Link>
  );
}
